export default __webpack_public_path__ + "static/media/group-size.37596511.svg";